<template lang='pug'>
div(style='width: 100%')
  .columnWidth
    ConnectionConfigs(:canalIgChannels='canalIgChannels')
</template>
<script>
import ConnectionConfigs from '@/components/Settings/CanalInstagram/ConnectionConfigs'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'
export default {
  components: {
    ConnectionConfigs
  },
  props: {
    canalWebData: {
      type: Object,
      default: () => ({})
    },
    canalWebId: {
      type: String,
      default: () => ''
    },
    canalIgChannels: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [isTenantMixin],
  watch: {
    canalWebData: {
      deep: true,
      handler (nV) {
        this.modified = true
      }
    }
  },
  computed: {
    ...mapFields('webChannel', ['modified'])
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.columnWidth {
  float: left;
  width: 50%;
}
@media (max-width: 1239px) {
  .columnWidth {
    float: left;
    width: 100%;
  }
}
</style>
